import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TerminalBackground } from "@/components/site/TerminalBackground";
import { TerminalCursor } from "@/components/site/TerminalCursor";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";

export const Layout = () => {
  return (
    <div className="App">
      <TerminalBackground />
      <TerminalCursor />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster position="top-right" richColors closeButton theme="dark" />
    </div>
  );
};
